export interface Buyer {
  name: string
  country: string
}

export const buyers: Buyer[] = [
  { name: 'Dr. Valeria Ortega', country: 'Mexico' },
  { name: 'Dr. Camilo Restrepo', country: 'Colombia' },
  { name: 'Dr. Lucía Fernández', country: 'Spain' },
  { name: 'Dr. Martín Sepúlveda', country: 'Chile' },
  { name: 'Dr. Ana Morales', country: 'Peru' },
  { name: 'Dr. Javier Domínguez', country: 'Argentina' },
  { name: 'Dr. Paula Castillo', country: 'Ecuador' },
  { name: 'Dr. Rodrigo Silva', country: 'Uruguay' },
  { name: 'Dr. Daniela Rojas', country: 'Costa Rica' },
  { name: 'Dr. Andrés Guzmán', country: 'Guatemala' },
  { name: 'Dr. Mariana Vargas', country: 'Bolivia' },
  { name: 'Dr. Sergio Navarro', country: 'Panama' },
  { name: 'Dr. Carolina Méndez', country: 'Dominican Republic' },
  { name: 'Dr. Tomás Herrera', country: 'Paraguay' },
]
